export default __webpack_public_path__ + "static/media/scrabble.136c3bb6.png";